var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodeMerge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.84131 7.88043C7.08865 7.51672 8 6.36479 8 5C8 3.34315 6.65685 2 5 2C3.34315 2 2 3.34315 2 5C2 6.39788 2.95608 7.57246 4.25 7.90549V16.0945C2.95608 16.4275 2 17.6021 2 19C2 20.6569 3.34315 22 5 22C6.65685 22 8 20.6569 8 19C8 17.6021 7.04392 16.4275 5.75 16.0945V10.873C6.80159 12.0263 8.31628 12.75 10 12.75H16.0945C16.4275 14.0439 17.6021 15 19 15C20.6569 15 22 13.6569 22 12C22 10.3431 20.6569 9 19 9C17.6021 9 16.4275 9.95608 16.0945 11.25H10C7.95465 11.25 6.24677 9.80515 5.84131 7.88043Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeMerge);
export default __webpack_public_path__ + "static/media/code-merge.363beac79b7c02c2586ee5ecbccb5ac0.svg";
export { ForwardRef as ReactComponent };